// bernie
import { SerializedData, Store } from 'bernie-core';
import { Logger } from 'bernie-logger';

// mobx
import { action } from 'mobx';

// data
import { User } from 'models';
import { UserSource } from 'sources';

export class UserStore extends Store {
  public constructor(private userSource: UserSource, state: SerializedData = {}, logger: Logger) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this.userSource, data.SignUpSource);
  }

  @action
  public createUser(user: User) {
    return this.userSource.createUser(user);
  }

  @action
  public sendVerificationEmail(email: string, locale: string) {
    return this.userSource.sendVerificationEmail(email, locale);
  }

  @action
  public sendForgotPasswordEmail(email: string, locale: string) {
    return this.userSource.sendForgotPasswordEmail(email, locale);
  }

  @action
  public setPassword(password: string) {
    return this.userSource.setPassword(password);
  }

  @action
  public verifyUser(email: string) {
    return this.userSource.verifyUser(email);
  }
}
